function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h17v17H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.811 3c.613 0 1.117.445 1.182 1.013l.007.124v8.726c0 .585-.464 1.068-1.06 1.13l-.129.007H2.19c-.613 0-1.117-.445-1.182-1.013L1 12.863V4.137c0-.585.464-1.068 1.06-1.13L2.188 3H14.81zm-4.549 5.934l-.308.296a2.09 2.09 0 01-1.454.577c-.488 0-.951-.162-1.32-.46l-.134-.117-.309-.296-4.635 4.447.087.007 12.663-.001.045-.006-4.635-4.447zm5.086-4.88L10.714 8.5l4.634 4.444.007-.081-.001-8.766-.006-.042zm-.45-.436l-.087-.006-12.663.001-.046.005 2.246 2.155a.295.295 0 01.046.375l-.046.055a.334.334 0 01-.408.039l-.05-.039-2.24-2.148-.005.082.001 8.766.005.041L6.285 8.5 4.503 6.791a.295.295 0 01-.046-.375l.046-.056a.335.335 0 01.4-.044l.058.044L7.504 8.8c.266.255.62.395.996.395.323 0 .628-.103.877-.293l.12-.103 5.4-5.181z",
  fill: "#53585C"
}))));